import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import { fetchFaq } from "@/shared/apiHelper";

const Faqs = ({ program }) => {
  const { t } = useTranslation();
  const [faq, setFaq] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    if (!program?.organization_id || !program?.id) {
      setFaq(null);
      setLoading(false);
      return undefined;
    }

    const loadFaq = async () => {
      setLoading(true);
      setError("");

      try {
        const data = await fetchFaq({
          organizationId: program.organization_id,
          programId: program.id,
          audienceType: "manager",
        });

        if (!isMounted) return;
        setFaq(data);
      } catch (err) {
        if (!isMounted) return;
        setFaq(null);
        setError("Unable to load FAQ content for this program.");
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadFaq();

    return () => {
      isMounted = false;
    };
  }, [program?.id, program?.organization_id]);

  const renderFaqContent = () => {
    if (loading) {
      return (
        <div className="faq-panel__loading" aria-live="polite" aria-busy="true">
          <div className="faq-panel__loading-line"></div>
          <div className="faq-panel__loading-line"></div>
          <div className="faq-panel__loading-line"></div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="faq-panel__empty">
          <p>{error}</p>
        </div>
      );
    }

    if (faq?.content) {
      return (
        <article className="faq-panel__article">
          <div
            className="faq-panel__prose"
            dangerouslySetInnerHTML={{ __html: faq.content }}
          />
        </article>
      );
    }

    return (
      <div className="faq-panel__empty">
        <p>{t("congratulations_faq")}</p>
        <p>{t("enjoy")}!</p>
      </div>
    );
  };

  return (
    <div className="manager-home manager-faq-page">
      <Container className="manager-home__shell manager-home__content">
        <div className="manager-faq">
          <section className="manager-card manager-faq__panel">
            <div className="manager-faq__panel-head">
              <div>
                <h1 className="manager-card__title">FAQ</h1>
              </div>
            </div>

            <div className="manager-faq__panel-body">{renderFaqContent()}</div>
          </section>
        </div>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    program: state.program,
  };
};

export default connect(mapStateToProps)(Faqs);
